import { useContext } from "react";
import { ThemeAssetContext } from "providers/ThemeProvider/ThemeProvider.context";

export const useThemeAssets = () => {
  return useContext(ThemeAssetContext);
};
